var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginSrangeLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 389,
    height: 982,
    viewBox: "0 0 389 982",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.76,
    d: "M312.101 -206.792C297.427 -558.474 -56.5247 -949.472 -231.666 -1101.01L-1520 -1098.95L-1517.87 1283.93L388.819 1280.88C295.206 1139.17 107.297 1096.6 41.5681 857.548C-40.5928 558.731 330.443 232.81 312.101 -206.792Z",
    fill: "#FF7E55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.975 -188.749C179.97 -538.553 -115.642 -928.001 -261.948 -1079H-1339V1291H255C176.845 1149.91 19.7845 1107.28 -34.9863 869.409C-103.45 572.075 206.981 248.506 191.975 -188.749Z",
    fill: "#FF7E55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginSrangeLine);
export default __webpack_public_path__ + "static/media/LoginSrangeLine.9627ddbdd6998ffe93056af2cfc4a284.svg";
export { ForwardRef as ReactComponent };